import React, { PropsWithChildren } from "react";

function TargetIcon(props: PropsWithChildren<any>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      fill="none"
      viewBox="0 0 28 28"
      style={{ cursor: "pointer" }}
      {...props}>
      <path
        fill="#522398"
        d="M14 9.188c-2.68 0-4.813 2.187-4.813 4.812A4.785 4.785 0 0014 18.813c2.625 0 4.813-2.133 4.813-4.813 0-2.625-2.188-4.813-4.813-4.813zm0 7c-1.258 0-2.188-.93-2.188-2.188 0-1.203.93-2.188 2.188-2.188 1.203 0 2.188.985 2.188 2.188 0 1.258-.985 2.188-2.188 2.188zm13.125-3.5h-2.734c-.602-4.704-4.375-8.477-9.078-9.079V.875c0-.438-.438-.875-.876-.875h-.874c-.493 0-.876.438-.876.875v2.734c-4.757.602-8.53 4.375-9.132 9.079H.875c-.492 0-.875.437-.875.874v.876c0 .492.383.874.875.874h2.68a10.562 10.562 0 009.132 9.133v2.68c0 .492.383.875.876.875h.874c.438 0 .876-.383.876-.875v-2.68c4.703-.601 8.476-4.375 9.078-9.133h2.734c.438 0 .875-.382.875-.874v-.876c0-.437-.438-.874-.875-.874zM14 21.874A7.842 7.842 0 016.125 14c0-4.32 3.5-7.875 7.875-7.875 4.32 0 7.875 3.555 7.875 7.875 0 4.375-3.555 7.875-7.875 7.875z"></path>
    </svg>
  );
}

export default React.memo(TargetIcon);
